const sections = {
    'Ad services': ['google', 'google-paid', 'google-grant', 'paid', 'grant', 'adwords', 'meta', 'bing', 'linkedin', 'tiktok', 'x', 'nextdoor', 'display', 'stackadapt', 'programmatic', 'infillion', 'mediamath', 'chatgpt-ads'],
    Email: ['email', 'mailchimp', 'mautic', 'delivera', 'delivra', 'constant-contact', 'constantcontact', 'salsa-labs', 'salsalabs', 'hubspot', 'luminate', 'klaviyo', 'salesforce-marketing-cloud'],
    Analytics: ['analytics', 'ga4', 'google-analytics', 'matomo'],
    Fundraising: ['donations', 'virtuous', 'gofundmepro', 'fundraiseup', 'qgiv', 'bloomerang', 'engagingnetworks', 'raisedonors', 'sky-api', 'skyapi'],
    Insights: ['instant-analysis', 'reportwerks-instant-analysis', 'reportwerks'],
    Workspace: ['notes', 'lightbox', 'lightboxes'],
};
const normalize = value => String(value || '').toLowerCase().replace(/_/g, '-');
const sectionFor = key => Object.keys(sections).find(section => sections[section].includes(normalize(key)));

export function getReportSection(item) {
    const route = normalize(item.rendererRoute || item.segment || item.to).replace(/^\/+|\/+$/g, '');
    if (['mr', 'overview', 'scv/mr', 'scv/overview'].includes(route)) return 'Overview';
    // The renderer identifies custom reports even when their saved labels or icons differ.
    for (const part of route.split('/').reverse()) {
        const section = sectionFor(part);
        if (section) return section;
    }
    return sectionFor(item.key) || sectionFor(item.icon) || 'Other reports';
}

export function groupReportNavigation(items = []) {
    const groups = new Map();
    for (const item of items) {
        if (item.kind === 'header' || item.kind === 'divider') continue;
        const section = getReportSection(item);
        if (!groups.has(section)) groups.set(section, []);
        groups.get(section).push(item);
    }
    // Keep the configured order within groups and the first-seen order of other sections.
    const order = [...groups.keys()];
    if (groups.has('Overview')) {
        order.splice(order.indexOf('Overview'), 1);
        order.unshift('Overview');
    }
    return order.flatMap(title => [{ kind: 'header', title }, ...groups.get(title)]);
}
